import React, { useMemo } from 'react'
import { Card, PictureArea, Sold } from '@/modern/components/Card'
import PhotoSlider from '@/components/PhotoSlider'
import useUrl from '@/modern/hooks/useUrl'
import { config } from 'config/config'
import { hasNewCardLayout } from '@/utils/utils'
import InfoAreaHorizontal from './InfoAreaHorizontal'
import InfoAreaVertical from './InfoAreaVertical'
import { PictureWrapper, CertifiedPurchaseTestAB } from './style'
import StampView360 from '../Stamps/View360'

const VehicleCardFactoryTestABCard = ({
  id,
  model,
  make,
  version,
  price,
  year,
  travelledDistance,
  location,
  seller,
  href = '#',
  photos = [],
  attributes = [],
  stamps = {},
  hasFavoriteActions = false,
  isHorizontal = false,
  wasFavorited = false,
  excludeFavoriteKey = false,
  wasSold = false,
  type,
  oldAd,
  color
}) => {
  const canIUseParceiroSantander = () => {
    const valorFeiroes = Object.values(stamps.feiroes)
    const temAlgumFeirao = valorFeiroes.includes(true)
    return !temAlgumFeirao && stamps.sellerBadges
  }

  const photosWithImageRender = () => {
    return photos.map(
      photo => photo + config.searchResult.image.imageHandlerRender
    )
  }

  const { addOrigin } = useUrl()

  const InfoAreaProps = {
    id,
    href: href + addOrigin(href),
    model,
    make,
    version,
    price,
    year,
    travelledDistance,
    location,
    seller,
    attributes,
    hasFavoriteActions,
    wasFavorited,
    excludeFavoriteKey,
    stamps,
    canIUseParceiroSantander,
    type,
    wasSold,
    color
  }
  const { IsElegibleVehicleInspection, IsElegible360View } = oldAd

  const vehicleTitle = useMemo(() => {
    return `${make} ${model} ${version || ''} ${year || ''}`.replace(
      /  +/g,
      ' '
    )
  }, [make, model, version, year])

  const hasTestABCard = hasNewCardLayout()
  
  return (
    <Card isHorizontal={isHorizontal} hasTestABCard={hasTestABCard}>
      <PictureWrapper>
        <CertifiedPurchaseTestAB shouldRender={IsElegibleVehicleInspection} />
        {IsElegible360View && <StampView360 />}
        <PictureArea isHorizontal={isHorizontal}>
          {wasSold ? (
            <Sold />
          ) : (
            <PhotoSlider
              width={config.searchResult.image.width}
              height={config.searchResult.image.height}
              linkCarousel={InfoAreaProps.href}
              listPhotos={photosWithImageRender()}
              tag={{
                title: vehicleTitle,
                alt: vehicleTitle,
              }}
            />
          )}
        </PictureArea>
      </PictureWrapper>

      {isHorizontal ? (
        <InfoAreaHorizontal {...InfoAreaProps} oldAd={oldAd} />
      ) : (
        <InfoAreaVertical {...InfoAreaProps} oldAd={oldAd} />
      )}
    </Card>
  )
}

export default VehicleCardFactoryTestABCard
